export const getMaxHeightOfOptionOrSelection = (
  maxHeight: number,
  heightOfSearchBox: number,
  heightOfFooter: number,
  minusPadding: number
) => {
  return (maxHeight - heightOfSearchBox - heightOfFooter) / 2 - minusPadding;
};
